import React, {Component} from 'react';
import QuestionInfo from '../components/QuestionInfo'
import QuestionList from '../components/QuestionList'
import InfoFooterApp from '../components/QuestionInfoFooter'
import Header from "../components/Header";
import Inner from '../components/Inner';

export default class Calculator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: true,
            hasOverflow: false
        };
    };

    onQuestionInfoUpdate = (info) => {
        const container = document.getElementsByClassName('mainContainerRightside')[0];
        // +5 is to compensade in IE and Edge where scrollHeight was 1px to heigher than offsetHeight in some cases.
        this.setState({hasOverflow: container.scrollHeight > container.offsetHeight + 5});
    };

    textToggle = () => {
        this.setState(prevState => ({
            isCollapsed: !prevState.isCollapsed
        }));
    };

    collapse = () => {
        this.setState({isCollapsed: true});
    }

    render() {
        const { isCollapsed, hasOverflow } = this.state;

        return (
            <div className="content-wrapper " id="content">

                <Header title="Frist&shy;beregneren" front={true}/>

                <Inner>
                    <div className="mainContainer">
                        <div className="mainContainerLeftside">
                            <div id="calculator-content">
                                <QuestionList collapse={this.collapse}/>
                            </div>
                        </div>
                        <div className={`mainContainerRightside ${isCollapsed ? 'collapsed' : ''}`}>
                            <QuestionInfo onUpdate={this.onQuestionInfoUpdate}/>

                            {hasOverflow && 
                                <span className="info-showmore" onClick={this.textToggle}>
                                    {isCollapsed ? 'Læs mere' : 'Læs mindre'}
                                    <span className="info-showmore-icon"></span>
                                </span>
                            }
                        </div>
                    </div>
                </Inner>
                <InfoFooterApp/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Calculator.js